/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BookingCorrectionDto,
  BookingDto,
  BookingsPageDto,
  CancelBlockingBookingsParams,
  CancelBookingRequestDto,
  CorrectBookingParams,
  CreateBookingRequestDto,
  FilterCriteriaForBookingDto,
  ReplaceBookingRequestDto,
  SearchBookingRequestDto,
  UpdateBookingRequestDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType , BodyType } from '../../../../custom-instance';




/**
 * @summary Cancel blocking bookings in a vehicle/time window (admin only)
 */
export const cancelBlockingBookings = (
    vehicleId: string,
    params: CancelBlockingBookingsParams,
 ) => {
      
      
      return customInstance<string[]>(
      {url: `/fleet/booking/v1/admin/vehicles/${vehicleId}/blocking-bookings`, method: 'DELETE',
        params
    },
      );
    }
  


export const getCancelBlockingBookingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBlockingBookings>>, TError,{vehicleId: string;params: CancelBlockingBookingsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelBlockingBookings>>, TError,{vehicleId: string;params: CancelBlockingBookingsParams}, TContext> => {

const mutationKey = ['cancelBlockingBookings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelBlockingBookings>>, {vehicleId: string;params: CancelBlockingBookingsParams}> = (props) => {
          const {vehicleId,params} = props ?? {};

          return  cancelBlockingBookings(vehicleId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelBlockingBookingsMutationResult = NonNullable<Awaited<ReturnType<typeof cancelBlockingBookings>>>
    
    export type CancelBlockingBookingsMutationError = ErrorType<unknown>

    /**
 * @summary Cancel blocking bookings in a vehicle/time window (admin only)
 */
export const useCancelBlockingBookings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBlockingBookings>>, TError,{vehicleId: string;params: CancelBlockingBookingsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelBlockingBookings>>,
        TError,
        {vehicleId: string;params: CancelBlockingBookingsParams},
        TContext
      > => {

      const mutationOptions = getCancelBlockingBookingsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary createBooking
 */
export const createBooking = (
    createBookingRequestDto: BodyType<CreateBookingRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingDto>(
      {url: `/fleet/booking/v1/bookings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBookingRequestDto, signal
    },
      );
    }
  


export const getCreateBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<CreateBookingRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<CreateBookingRequestDto>}, TContext> => {

const mutationKey = ['createBooking'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createBooking>>, {data: BodyType<CreateBookingRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  createBooking(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof createBooking>>>
    export type CreateBookingMutationBody = BodyType<CreateBookingRequestDto>
    export type CreateBookingMutationError = ErrorType<unknown>

    /**
 * @summary createBooking
 */
export const useCreateBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createBooking>>, TError,{data: BodyType<CreateBookingRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createBooking>>,
        TError,
        {data: BodyType<CreateBookingRequestDto>},
        TContext
      > => {

      const mutationOptions = getCreateBookingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary replaceBooking
 */
export const replaceBooking = (
    replaceBookingRequestDto: BodyType<ReplaceBookingRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingDto>(
      {url: `/fleet/booking/v1/bookings/actions/replacements`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: replaceBookingRequestDto, signal
    },
      );
    }
  


export const getReplaceBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceBooking>>, TError,{data: BodyType<ReplaceBookingRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replaceBooking>>, TError,{data: BodyType<ReplaceBookingRequestDto>}, TContext> => {

const mutationKey = ['replaceBooking'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceBooking>>, {data: BodyType<ReplaceBookingRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  replaceBooking(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReplaceBookingMutationResult = NonNullable<Awaited<ReturnType<typeof replaceBooking>>>
    export type ReplaceBookingMutationBody = BodyType<ReplaceBookingRequestDto>
    export type ReplaceBookingMutationError = ErrorType<unknown>

    /**
 * @summary replaceBooking
 */
export const useReplaceBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceBooking>>, TError,{data: BodyType<ReplaceBookingRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceBooking>>,
        TError,
        {data: BodyType<ReplaceBookingRequestDto>},
        TContext
      > => {

      const mutationOptions = getReplaceBookingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Get bookings for client
 */
export const getBookingsForClient = (
    clientId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingsPageDto>(
      {url: `/fleet/booking/v1/bookings/client/${clientId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBookingsForClientQueryKey = (clientId?: string,) => {
    return [`/fleet/booking/v1/bookings/client/${clientId}`] as const;
    }

    
export const getGetBookingsForClientQueryOptions = <TData = Awaited<ReturnType<typeof getBookingsForClient>>, TError = ErrorType<unknown>>(clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingsForClient>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingsForClientQueryKey(clientId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingsForClient>>> = ({ signal }) => getBookingsForClient(clientId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingsForClient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingsForClientQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingsForClient>>>
export type GetBookingsForClientQueryError = ErrorType<unknown>


export function useGetBookingsForClient<TData = Awaited<ReturnType<typeof getBookingsForClient>>, TError = ErrorType<unknown>>(
 clientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingsForClient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingsForClient>>,
          TError,
          Awaited<ReturnType<typeof getBookingsForClient>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingsForClient<TData = Awaited<ReturnType<typeof getBookingsForClient>>, TError = ErrorType<unknown>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingsForClient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingsForClient>>,
          TError,
          Awaited<ReturnType<typeof getBookingsForClient>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingsForClient<TData = Awaited<ReturnType<typeof getBookingsForClient>>, TError = ErrorType<unknown>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingsForClient>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get bookings for client
 */

export function useGetBookingsForClient<TData = Awaited<ReturnType<typeof getBookingsForClient>>, TError = ErrorType<unknown>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingsForClient>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingsForClientQueryOptions(clientId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary searchBookings
 */
export const searchBookings = (
    searchBookingRequestDto: BodyType<SearchBookingRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingsPageDto>(
      {url: `/fleet/booking/v1/bookings/searches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchBookingRequestDto, signal
    },
      );
    }
  


export const getSearchBookingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchBookings>>, TError,{data: BodyType<SearchBookingRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof searchBookings>>, TError,{data: BodyType<SearchBookingRequestDto>}, TContext> => {

const mutationKey = ['searchBookings'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof searchBookings>>, {data: BodyType<SearchBookingRequestDto>}> = (props) => {
          const {data} = props ?? {};

          return  searchBookings(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SearchBookingsMutationResult = NonNullable<Awaited<ReturnType<typeof searchBookings>>>
    export type SearchBookingsMutationBody = BodyType<SearchBookingRequestDto>
    export type SearchBookingsMutationError = ErrorType<unknown>

    /**
 * @summary searchBookings
 */
export const useSearchBookings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof searchBookings>>, TError,{data: BodyType<SearchBookingRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof searchBookings>>,
        TError,
        {data: BodyType<SearchBookingRequestDto>},
        TContext
      > => {

      const mutationOptions = getSearchBookingsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary getBooking
 */
export const getBooking = (
    bookingId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingDto>(
      {url: `/fleet/booking/v1/bookings/${bookingId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetBookingQueryKey = (bookingId?: string,) => {
    return [`/fleet/booking/v1/bookings/${bookingId}`] as const;
    }

    
export const getGetBookingQueryOptions = <TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<unknown>>(bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBooking>>> = ({ signal }) => getBooking(bookingId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingQueryResult = NonNullable<Awaited<ReturnType<typeof getBooking>>>
export type GetBookingQueryError = ErrorType<unknown>


export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<unknown>>(
 bookingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooking>>,
          TError,
          Awaited<ReturnType<typeof getBooking>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<unknown>>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBooking>>,
          TError,
          Awaited<ReturnType<typeof getBooking>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<unknown>>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getBooking
 */

export function useGetBooking<TData = Awaited<ReturnType<typeof getBooking>>, TError = ErrorType<unknown>>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBooking>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingQueryOptions(bookingId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary cancelBooking
 */
export const cancelBooking = (
    bookingId: string,
    cancelBookingRequestDto: BodyType<CancelBookingRequestDto>,
 signal?: AbortSignal
) => {
      
      
      return customInstance<BookingDto>(
      {url: `/fleet/booking/v1/bookings/${bookingId}/actions/cancellations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelBookingRequestDto, signal
    },
      );
    }
  


export const getCancelBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBooking>>, TError,{bookingId: string;data: BodyType<CancelBookingRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelBooking>>, TError,{bookingId: string;data: BodyType<CancelBookingRequestDto>}, TContext> => {

const mutationKey = ['cancelBooking'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelBooking>>, {bookingId: string;data: BodyType<CancelBookingRequestDto>}> = (props) => {
          const {bookingId,data} = props ?? {};

          return  cancelBooking(bookingId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelBookingMutationResult = NonNullable<Awaited<ReturnType<typeof cancelBooking>>>
    export type CancelBookingMutationBody = BodyType<CancelBookingRequestDto>
    export type CancelBookingMutationError = ErrorType<unknown>

    /**
 * @summary cancelBooking
 */
export const useCancelBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelBooking>>, TError,{bookingId: string;data: BodyType<CancelBookingRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelBooking>>,
        TError,
        {bookingId: string;data: BodyType<CancelBookingRequestDto>},
        TContext
      > => {

      const mutationOptions = getCancelBookingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Re-run the mileage-correction logic against the booking. By default the booking must be flagged `needsCorrection`; pass `force=true` to bypass that precondition (e.g. when an admin wants to retroactively fix mileage that was missing but never got flagged).
 * @summary correctBooking
 */
export const correctBooking = (
    bookingId: string,
    params?: CorrectBookingParams,
 ) => {
      
      
      return customInstance<BookingCorrectionDto>(
      {url: `/fleet/booking/v1/bookings/${bookingId}/actions/correct`, method: 'PUT',
        params
    },
      );
    }
  


export const getCorrectBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctBooking>>, TError,{bookingId: string;params?: CorrectBookingParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof correctBooking>>, TError,{bookingId: string;params?: CorrectBookingParams}, TContext> => {

const mutationKey = ['correctBooking'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof correctBooking>>, {bookingId: string;params?: CorrectBookingParams}> = (props) => {
          const {bookingId,params} = props ?? {};

          return  correctBooking(bookingId,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CorrectBookingMutationResult = NonNullable<Awaited<ReturnType<typeof correctBooking>>>
    
    export type CorrectBookingMutationError = ErrorType<unknown>

    /**
 * @summary correctBooking
 */
export const useCorrectBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof correctBooking>>, TError,{bookingId: string;params?: CorrectBookingParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof correctBooking>>,
        TError,
        {bookingId: string;params?: CorrectBookingParams},
        TContext
      > => {

      const mutationOptions = getCorrectBookingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary getBookingFilters
 */
export const getBookingFilters = (
    bookingId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<FilterCriteriaForBookingDto>(
      {url: `/fleet/booking/v1/bookings/${bookingId}/filters`, method: 'GET', signal
    },
      );
    }
  

export const getGetBookingFiltersQueryKey = (bookingId?: string,) => {
    return [`/fleet/booking/v1/bookings/${bookingId}/filters`] as const;
    }

    
export const getGetBookingFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getBookingFilters>>, TError = ErrorType<unknown>>(bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookingFiltersQueryKey(bookingId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingFilters>>> = ({ signal }) => getBookingFilters(bookingId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(bookingId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookingFilters>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookingFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getBookingFilters>>>
export type GetBookingFiltersQueryError = ErrorType<unknown>


export function useGetBookingFilters<TData = Awaited<ReturnType<typeof getBookingFilters>>, TError = ErrorType<unknown>>(
 bookingId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingFilters>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingFilters>>,
          TError,
          Awaited<ReturnType<typeof getBookingFilters>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingFilters<TData = Awaited<ReturnType<typeof getBookingFilters>>, TError = ErrorType<unknown>>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingFilters>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingFilters>>,
          TError,
          Awaited<ReturnType<typeof getBookingFilters>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookingFilters<TData = Awaited<ReturnType<typeof getBookingFilters>>, TError = ErrorType<unknown>>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary getBookingFilters
 */

export function useGetBookingFilters<TData = Awaited<ReturnType<typeof getBookingFilters>>, TError = ErrorType<unknown>>(
 bookingId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookingFilters>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookingFiltersQueryOptions(bookingId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary updateBooking
 */
export const updateBooking = (
    bookingId: string,
    updateBookingRequestDto: BodyType<UpdateBookingRequestDto>,
 ) => {
      
      
      return customInstance<BookingDto>(
      {url: `/fleet/booking/v2/bookings/${bookingId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateBookingRequestDto
    },
      );
    }
  


export const getUpdateBookingMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBooking>>, TError,{bookingId: string;data: BodyType<UpdateBookingRequestDto>}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateBooking>>, TError,{bookingId: string;data: BodyType<UpdateBookingRequestDto>}, TContext> => {

const mutationKey = ['updateBooking'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateBooking>>, {bookingId: string;data: BodyType<UpdateBookingRequestDto>}> = (props) => {
          const {bookingId,data} = props ?? {};

          return  updateBooking(bookingId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBookingMutationResult = NonNullable<Awaited<ReturnType<typeof updateBooking>>>
    export type UpdateBookingMutationBody = BodyType<UpdateBookingRequestDto>
    export type UpdateBookingMutationError = ErrorType<unknown>

    /**
 * @summary updateBooking
 */
export const useUpdateBooking = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateBooking>>, TError,{bookingId: string;data: BodyType<UpdateBookingRequestDto>}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateBooking>>,
        TError,
        {bookingId: string;data: BodyType<UpdateBookingRequestDto>},
        TContext
      > => {

      const mutationOptions = getUpdateBookingMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    